// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
/* rtl:begin:ignore */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spinner-module__spinner___Ocvyt {
  border-right: 4px solid var(--primary50, #f2eff4);
  border-top: 4px solid var(--primary200, #d8cbe5);
  border-left: 4px solid var(--primary600, #4b286d);
  border-bottom: 4px solid var(--primary700, #371e47);
  border-radius: 100%;
  height: 40px;
  left: 50%;
  margin: 10px 0 0 -20px;
  opacity: 1;
  position: absolute;
  top: 100%;
  transition: all 0.3s ease 0s;
  width: 40px;
  z-index: 10000;
}
.spinner-module__spinner___Ocvyt {
  animation: spin 0.75s infinite linear;
}
.spinner-module__spinner--small___GWbcu {
  border-width: 2px;
  height: 20px;
  width: 20px;
  margin: 10px 0 0 -10px;
}
.spinner-module__spinner--fixed-center___OesfC, .spinner-module__spinner--center___f1kdI {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.spinner-module__spinner--center___f1kdI {
  position: absolute;
}
.spinner-module__spinner--fixed-center___OesfC {
  position: fixed;
}
.spinner-module__spinner--with-content___tr53i {
  position: relative;
}
.spinner-module__spinner--leaderboard___NDOEg, .spinner-module__spinner--tier-activity___oHUGs {
  position: relative;
  margin-bottom: 60px;
}

/* rtl:end:ignore */
.spinner-module__mask___NE4EC {
  min-height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  z-index: 10;
}
.spinner-module__mask--wellbeing___ulBFJ {
  top: 100px;
}
.spinner-module__mask--inline___pUjT6 {
  display: inline-block;
}
.spinner-module__mask--inline___pUjT6,
.spinner-module__mask--inline___pUjT6 .spinner-module__spinner___Ocvyt {
  position: relative;
  top: 0;
  left: 0;
  margin: 0;
}

.spinner-module__bottom-spacing___GTv26 {
  padding-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/general/spinner/spinner.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA,qBAAA;AACA;EACE;IACE,uBAAA;EAMF;EAJA;IACE,yBAAA;EAMF;AACF;AAHA;EAIE,iDAAA;EACA,gDAAA;EACA,iDAAA;EACA,mDAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,4BAAA;EACA,WAAA;EACA,cAAA;AAEF;AAlBE;EACE,qCAAA;AAoBJ;AAJE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAMJ;AAHE;EAEE,QAAA;EACA,SAAA;EACA,gCAAA;AAIJ;AADE;EACE,kBAAA;AAGJ;AAAE;EACE,eAAA;AAEJ;AACE;EACE,kBAAA;AACJ;AAEE;EAEE,kBAAA;EACA,mBAAA;AADJ;;AAKA,mBAAA;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;AAHF;AAKE;EACE,UAAA;AAHJ;AAME;EACE,qBAAA;AAJJ;AAKI;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;AAHN;;AAQA;EACE,oBAAA;AALF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils.scss';\n\n/* rtl:begin:ignore */\n@keyframes :global(spin) {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner {\n  :global {\n    animation: spin 0.75s infinite linear;\n  }\n  border-right: 4px solid color(primary50);\n  border-top: 4px solid color(primary200);\n  border-left: 4px solid color(primary600);\n  border-bottom: 4px solid color(primary700);\n  border-radius: 100%;\n  height: 40px;\n  left: 50%;\n  margin: calc($spacing / 2) 0 0 #{-$spacing};\n  opacity: 1;\n  position: absolute;\n  top: 100%;\n  transition: all 0.3s ease 0s;\n  width: 40px;\n  z-index: 10000;\n  &--small {\n    border-width: 2px;\n    height: 20px;\n    width: 20px;\n    margin: calc($spacing / 2) 0 0 #{-$spacing * 0.5};\n  }\n\n  &--fixed-center,\n  &--center {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &--center {\n    position: absolute;\n  }\n\n  &--fixed-center {\n    position: fixed;\n  }\n\n  &--with-content {\n    position: relative;\n  }\n\n  &--leaderboard,\n  &--tier-activity {\n    position: relative;\n    margin-bottom: 60px;\n  }\n}\n\n/* rtl:end:ignore */\n\n.mask {\n  min-height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  min-width: 100%;\n  z-index: 10;\n\n  &--wellbeing {\n    top: 100px;\n  }\n\n  &--inline {\n    display: inline-block;\n    &,\n    .spinner {\n      position: relative;\n      top: 0;\n      left: 0;\n      margin: 0;\n    }\n  }\n}\n\n.bottom-spacing {\n  padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `spinner-module__spinner___Ocvyt`,
	"spinner--small": `spinner-module__spinner--small___GWbcu`,
	"spinner--fixed-center": `spinner-module__spinner--fixed-center___OesfC`,
	"spinner--center": `spinner-module__spinner--center___f1kdI`,
	"spinner--with-content": `spinner-module__spinner--with-content___tr53i`,
	"spinner--leaderboard": `spinner-module__spinner--leaderboard___NDOEg`,
	"spinner--tier-activity": `spinner-module__spinner--tier-activity___oHUGs`,
	"mask": `spinner-module__mask___NE4EC`,
	"mask--wellbeing": `spinner-module__mask--wellbeing___ulBFJ`,
	"mask--inline": `spinner-module__mask--inline___pUjT6`,
	"bottom-spacing": `spinner-module__bottom-spacing___GTv26`
};
export default ___CSS_LOADER_EXPORT___;
